module.exports = __webpack_public_path__ + "static/media/day21_async.7a616422.gif";